export interface ConsultationForm {
  name: string
  phone: string
  email?: string
  company?: string
  industry?: string
  message?: string
}

export interface ConsultationResponse {
  code: string | number // 后端返回 "0" 表示成功
  msg: string // 提示信息
  data: any | null // 返回数据，可能为 null
}

export const useConsultationApi = () => {
  const { apiFetch } = useApi()

  /**
   * 提交咨询留言表单
   * @param formData 表单数据
   */
  const submitConsultation = (formData: ConsultationForm) => {
    return apiFetch<ConsultationResponse>('/kdev/online_consultation/', {
      method: 'POST',
      body: formData,
    })
  }

  return {
    submitConsultation,
  }
}
